/**
 * Complete the look — live free-shipping unlock badge.
 *
 * The badge is rendered server-side in snippets/complete-the-look-card.liquid
 * based on the cart at page load. This script keeps it in sync when the cart
 * changes over AJAX, so the shopper does not need to refresh the page.
 *
 * Two cart systems can change the cart on this store:
 *   - The Maestrooo theme dispatches `cart:updated` with the full cart object.
 *   - The Rebuy Smart Cart app handles the slide-out cart. Rebuy bridges to
 *     `cart:updated` when items are ADDED, but on REMOVE / quantity change it
 *     only fires its own `rebuy:*` events and those payloads do not include the
 *     cart total. For those we re-fetch the authoritative total from /cart.js.
 *
 * Each badge element carries:
 *   data-ctl-unlock           marker attribute
 *   data-ctl-threshold        free shipping threshold, in cents
 *   data-ctl-add-price        the card product's add price, in cents
 *
 * The badge shows when the cart is below the threshold AND adding that product
 * would reach it: cartTotal < threshold && cartTotal + addPrice >= threshold.
 */
(function () {
  if (window.__ctlUnlockBound) {
    return;
  }
  window.__ctlUnlockBound = true;

  function updateBadges(total) {
    if (typeof total !== 'number' || isNaN(total)) {
      return;
    }

    var badges = document.querySelectorAll('[data-ctl-unlock]');
    for (var i = 0; i < badges.length; i++) {
      var el = badges[i];
      var threshold = parseInt(el.getAttribute('data-ctl-threshold'), 10);
      var addPrice = parseInt(el.getAttribute('data-ctl-add-price'), 10);

      if (isNaN(threshold) || threshold <= 0 || isNaN(addPrice)) {
        continue;
      }

      var shouldShow = total < threshold && total + addPrice >= threshold;
      el.hidden = !shouldShow;
    }
  }

  // Coalesce bursts of events (Rebuy fires several per interaction) into a
  // single /cart.js fetch.
  var refreshTimer = null;
  function refreshFromServer() {
    if (refreshTimer) {
      clearTimeout(refreshTimer);
    }
    refreshTimer = setTimeout(function () {
      refreshTimer = null;
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.ok ? response.json() : null;
        })
        .then(function (cart) {
          if (cart && typeof cart.total_price === 'number') {
            updateBadges(cart.total_price);
          }
        })
        .catch(function () {
          /* network error — leave the badge in its current state */
        });
    }, 120);
  }

  // Fast path: the theme (and Rebuy on add) gives us the full cart object.
  document.addEventListener('cart:updated', function (event) {
    if (event.detail && event.detail.cart && typeof event.detail.cart.total_price === 'number') {
      updateBadges(event.detail.cart.total_price);
    } else {
      refreshFromServer();
    }
  });

  // Rebuy Smart Cart events. These fire on add, remove, and quantity changes,
  // but do not carry the cart total — so re-fetch it.
  var rebuyEvents = [
    'rebuy:cart.change',
    'rebuy:smartcart.line-item-removed',
    'rebuy.productsChange'
  ];
  for (var e = 0; e < rebuyEvents.length; e++) {
    document.addEventListener(rebuyEvents[e], refreshFromServer);
  }
})();
